import {inject, Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Pipe({standalone: true, name: 'historyFieldPipe'})
export class HistoryFieldPipe implements PipeTransform
{
  private translate = inject(TranslateService);

  transform(fieldName: string): string
  {
    if (!fieldName)
      return '';

    const key = 'FIELDNAME_' + fieldName;
    const translated = this.translate.instant(key);
    if (translated && translated !== key)
      return translated;
    else return fieldName;
  }
}
